"use client";

import React from "react";
import { ArrowRight, Mail, MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const contactDetails = [{
  title: "Odszkodowania Słupsk",
  content: "ul. Adama Mickiewicza 57\n76-200 Słupsk",
  icon: MapPin
}, {
  title: "Telefon",
  content: "504 144 406",
  icon: Phone
}, {
  title: "E-mail",
  content: "b.parchomiuk@trasta.pl",
  icon: Mail
}];
export default function Contact() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="contact" className="bg-background">
      <div className="bg-[var(--color-dark-background)] text-[var(--color-foreground-dark)] py-24 md:py-32 relative overflow-hidden">
        {}
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[var(--color-primary-dark)]/20 to-transparent pointer-events-none" />

        <div className="container mx-auto px-6 md:px-12 lg:px-24 max-w-7xl relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-12">
            
            {}
            <div ref={leftRef} className={`lg:col-span-5 flex flex-col justify-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-semibold mb-8 text-[var(--color-foreground-dark)] leading-tight">
                Skontaktuj się <br className="hidden lg:block" />z nami
              </h2>
              <p className="font-serif text-lg md:text-xl text-[var(--color-muted)] mb-8 leading-relaxed max-w-xl">
                Jeżeli doznałeś szkody osobowej, brałeś udział w wypadku lub potrzebujesz oceny swojej sytuacji prawnej, skontaktuj się w celu analizy sprawy.
              </p>
            </div>

            {}
            <div ref={rightRef} className={`lg:col-span-6 lg:col-start-7 flex flex-col gap-12 transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] delay-100 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <div className="grid gap-8">
                {contactDetails.map((item, i) => <div key={i} data-index={i} className="flex items-start gap-6 group">
                    <div className="w-12 h-12 rounded-full bg-[var(--color-dark-background)] border border-[var(--color-border-strong)]/30 flex items-center justify-center shrink-0 group-hover:bg-[var(--color-primary-dark)] transition-colors duration-[var(--duration-medium)]">
                      <item.icon className="w-5 h-5 text-[var(--color-secondary)]" />
                    </div>
                    <div>
                      <h3 className="font-display font-semibold text-xl text-[var(--color-foreground-dark)] mb-2 tracking-wide">
                        {item.title}
                      </h3>
                      <p className="font-serif text-[var(--color-muted)] whitespace-pre-line leading-relaxed">
                        {item.content}
                      </p>
                    </div>
                  </div>)}
              </div>

              <div className="pt-8 border-t border-[var(--color-border)]/10">
                <Button asChild size="lg" className="bg-[var(--color-secondary)] text-[var(--color-foreground-secondary)] hover:bg-[var(--color-secondary-hover)] w-full sm:w-auto text-lg px-10 py-7 rounded-md font-display font-semibold uppercase tracking-[1px] shadow-strong hover:-translate-y-1 transition-all duration-[var(--duration-medium)]">
                  <Link to="tel:504144406">
                    Zadzwoń teraz <ArrowRight className="ml-3 w-6 h-6" />
                  </Link>
                </Button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>;
}